import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { FormikMultiSelect } from '../../../../../components/FormikFields'
import { PW_MANAGER_SELECT_PROPS } from '../../../../../util/inputAttrs'
import { getLoginOptions } from '../../AddEditUserModal/utils'

/**
 * Sign-in methods a system user may use, bound to the surrounding Formik form.
 */
function LoginOptionsField({ isDisabled = false }) {
  const intl = useIntl()
  const loginOptions = useMemo(() => getLoginOptions(intl), [intl])

  return (
    <FormikMultiSelect
      id="loginOptions"
      isDisabled={isDisabled}
      options={loginOptions}
      placeholder={intl.formatMessage({ id: 'USERS.SELECT_LOGIN_OPTIONS' })}
      {...PW_MANAGER_SELECT_PROPS}
    />
  )
}

LoginOptionsField.propTypes = { isDisabled: PropTypes.bool }

export default React.memo(LoginOptionsField)
